import { useGet, useAuth } from "@onefront/react-sdk";
import { useCurrentTenant } from "@drift/oneplatfront";
import { generateHeaders } from "../../../utils/generate-headers";

interface ParamsFetch {
    headers?: any;
}

interface IuseGetBusiness {
    (workspaceId?: string, businessId?: string, service?: string, lazy?: boolean): {
        data?: any;
        loading?: boolean;
        fetch?: (fetchConfig?: ParamsFetch) => Promise<any>;
    };
}

export const useGetAdditionalBusinessDetails: IuseGetBusiness = (workspaceId, businessId, service, lazy = false) => {
    const { tenant } = useCurrentTenant(true);
    return useGet(`rnd:core:workspace-read:api://v1/workspaces/${workspaceId}/business/${businessId}/${service}`, {
        params: {},
        headers: {
            ...generateHeaders(useAuth(), tenant?.itemId, workspaceId)
        },
        lazy
    });
};
